import { Box, Typography, useMediaQuery } from "@mui/material";

import CampaignCard from "../../../components/common/CampaignCard/CampaignCard";
import CampaignCardSkeleton from "../../../components/common/CampaignCard/CampaignCardSkeleton";
import { SectionHeading, SwipeRow, TEMPLE_COLORS } from "../shared";

// Cards are live temple campaigns (Admin → Temples → Featured Temples).
const FeaturedTemplesSection = ({ content, temples, loading }) => {
  const isMobile = useMediaQuery("(max-width: 599px)");
  const isEmpty = !loading && temples.length === 0;
  const cards = loading
    ? Array.from({ length: 3 }, (_, index) => <CampaignCardSkeleton key={index} isCampaign />)
    : temples.map((temple) => <CampaignCard key={temple.id} campaignData={temple} isCampaign />);

  const emptyMessage = (
    <Typography sx={{ mt: isMobile ? 0 : "40px", px: "20px", textAlign: "center", fontSize: "16px", color: TEMPLE_COLORS.muted }}>
      New temple restoration projects are on their way. Check back soon.
    </Typography>
  );

  if (isMobile) {
    return (
      <Box
        component="section"
        id="featured-temples"
        sx={{ background: "#F7F7F7", py: "76px", display: "flex", flexDirection: "column", gap: "24px", scrollMarginTop: "16px" }}
      >
        <Box sx={{ px: "20px" }}>
          <SectionHeading tag={content.tag} title={content.title} description={content.description} isMobile />
        </Box>
        {isEmpty ? emptyMessage : <SwipeRow itemWidth={300} px={20}>{cards}</SwipeRow>}
      </Box>
    );
  }

  return (
    <Box
      component="section"
      id="featured-temples"
      sx={{
        background: "linear-gradient(180deg, #FFFFFF 0%, #F9F9F9 100%)",
        px: "40px",
        py: "100px",
        scrollMarginTop: "16px",
      }}
    >
      <SectionHeading tag={content.tag} title={content.title} description={content.description} />
      {isEmpty ? (
        emptyMessage
      ) : (
        <Box
          sx={{
            mt: "56px",
            mx: "auto",
            maxWidth: 1299,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, 417px)",
            justifyContent: "center",
            columnGap: "24px",
            rowGap: "56px",
          }}
        >
          {cards}
        </Box>
      )}
    </Box>
  );
};

export default FeaturedTemplesSection;
